export default __webpack_public_path__ + "static/media/EAST1070.34I-34200_-18445_0.9dc238fc.jpg";